import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const LAND_HUB_LAYER: Layer = {
  id: ConstraintsCategory.LAND_HUB,
  layerType: ConstraintsLayerType,
  title: "Homes England",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-layer-homes-england",
  description: "Sites available for disposal through Homes England Land Hub",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.LAND_HUB,
    categorySchema: [{ key: "land_hub_pipeline" }, { key: "land_hub_on_market" }, { key: "land_hub_sold_stc" }],
  },
};
